package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.background
import com.varabyte.kobweb.compose.css.backgroundColor
import com.varabyte.kobweb.compose.css.backgroundImage
import com.varabyte.kobweb.compose.css.backgroundPosition
import com.varabyte.kobweb.compose.css.backgroundSize
import com.varabyte.kobweb.compose.css.content
import com.varabyte.kobweb.compose.css.justifyContent
import com.varabyte.kobweb.compose.css.textAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.*
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.constants.HLDITheme.Colors.background

val HomeHeroStyle = CssStyle {
    base {
        Modifier
            .position(Position.Relative)
            .height(100.vh)
            .backgroundColor(HLDITheme.Colors.primary)
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .textAlign(TextAlign.Center)
            .color(HLDITheme.Colors.white)
    }

    // ::before pseudo-element — gradient overlay sitting above the base
    // background-color
    cssRule("::before") {
        Modifier
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .right(0.px)
            .bottom(0.px)
            .zIndex(1)
            .styleModifier {
                property("content", "\"\"")
                property(
                    "background",
                    "linear-gradient(135deg, rgba(11, 102, 35, 0.9) 0%, rgba(46, 139, 87, 0.8) 100%)"
                )
            }
    }

    // Ensure direct children render above the overlay
    cssRule("> *") {
        Modifier
            .position(Position.Relative)
            .zIndex(2)
    }
}
